'use strict'

import hyperdom from 'hyperdom'
import * as gtmDataLayer from './analytics/gtm/dataLayer.js'

class Faq {
  constructor (config, faqs, user) {
    this.config = config
    this.user = user
    this.faqs = faqs
    this.groupedFaqs = groupFaqs(faqs)
    this.selected = {}
  }

  onadd () {
    gtmDataLayer.activateOptimize()
  }

  onupdate () {
    gtmDataLayer.activateOptimize()
  }

  render () {
    if (this.faqs && this.faqs.length === 0)
      return null

    return <div id='faq' class='modal__content'>
      <div class='faq__titles'>
        <h1>Frequently Asked Questions</h1>
        <h2>Need answers? Find them here</h2>
      </div>
      {
        Object.keys(this.groupedFaqs).map(groupName => {
          var faqs = this.groupedFaqs[groupName]
          var selected = groupName === this.selected.group

          return <div class={['faq__group', {'-selected': selected}]}>
            <h3 class='faq__header' onclick={() => this.toggleSelectedGroup(groupName)}>
              {groupName}
            </h3>
            {
              selected
                ? faqs.map(faq => {
                  var faqSelected = faq === this.selected.faq
                  var answer = faq.answer.replace(/\{\{phone\}\}/g, this.config.phone.general)
                  return <div class={['faq__item', {'-selected': faqSelected}]}>
                    <h4 class='faq__question' onclick={() => this.toggleSelected('faq', faq)}>
                      {faq.question}
                    </h4>
                    {hyperdom.rawHtml('div.faq__answer', answer)}
                  </div>
                })
                : undefined
            }
          </div>
        })
      }

      {/*<div class='u-margin-top-large'>*/}
      {/*  <h4 class='o-heading-icon icon-feedback'>Feedback and suggestions</h4>*/}
      {/*  <p>We would love to hear about your experience on the site<br /><a href='#' onclick={(ev) => { ev.preventDefault(); window.fby.push(['showForm', '10142']); return false }}>Leave feedback or a suggestion</a></p>*/}
      {/*</div>*/}
    </div>
  }

  toggleSelectedGroup (value) {
    this.toggleSelected('group', value)
    this.selected.faq = undefined
  }

  toggleSelected (name, value) {
    if (this.selected[name] === value) {
      this.selected[name] = undefined
    } else {
      this.selected[name] = value
    }
  }
}

function groupFaqs (faqs) {
  var groups = {}

  faqs.forEach(faq => {
    faq.groups.forEach(group => {
      var questions = groups[group]
      if (!questions) {
        questions = groups[group] = []
      }
      questions.push(faq)
    })
  })

  return groups
}

export default Faq
